import React from 'react';
import { Contacts } from '@utils/constants/global';

export default (
  <>
    <p>Rove has the following cancellation policy:</p>
    <ul>
      <li>
        All reservations made 14 days before the check-in date are fully
        refundable for 48 hours
      </li>
      <li>
        Reservations can be cancelled for a full refund if cancelled greater
        than 60 days before the check-in date
      </li>
      <li>
        Reservations between 60 and 30 days from the check-in date can be
        cancelled for a credit towards a future Rove booking within the next 12
        months.
      </li>
      <li>Reservations cannot be cancelled less than 30 days from check-in.</li>
    </ul>
    <p>
      Please email{' '}
      <a href={`mailto:${Contacts.CONTACT_EMAIL}`}>{Contacts.CONTACT_EMAIL}</a>{' '}
      for any questions regarding cancellations.
    </p>
  </>
);
